import React, { Component } from "react";
import "./AuthUserList.css";
import Config from "../../config";
import Axios from "axios";
import { DatePicker, Row, Spin, Col, Input, Button,Pagination } from "antd";
import { Form } from '@ant-design/compatible';
import $, { post } from "jquery";
import DownloadIcon from "./DownloadIcon.png";
import CrossIcon from "./CrossIcon.png";
import SearchIcon from "./SearchIcon.png";
import ExportJsonExcel from "js-export-excel";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import dayjs from 'dayjs';
import paginationDecrement from "./paginationDecrement.png";
import paginationIncrement from "./paginationIncrement.png";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';


export class AuthUserListsonder extends Component {
    constructor(props) {
        super(props);

        this.state = {

            columnHeadersForsonder: [
                "Reference",
                "Member Name",
                "Sub ID",
                "Provider NPI",
                "POS",
                "From Date",
                "To Date",
                "Cpt Code", 
                "Received Date",
                "Auth Status",  
            ],
          
            filtercptCode: "",
            filterposAbb: "",
            filterproviderNPI: "",
            filterreceivedDate: "",
            filtersubscriberID: "",
            filterReference: "",
            filterSubId: "",
            filterMemberName: "",
            filterFromData: "",
            filterToData: "",
            filterDOS: "",
            filterStatus: "",
            filterPos: "",
            filterAuth: "",
            filterServicing: "",
            filterFacility: "",
            rowsPerPage: 12, 
            authListData: [],
            filterData: [],
            authListLoading: false,
            SearchLoading: false,
            searchColumn: "",
            pageNumber: 1,
            totalPagescount: "",
            pageSize: 10,
            totalCount: "",
            currentPage: 1,
            pageBound: 1,
            id: "",
            filterPageNumber: 1,
            // serialNumber : ""
            tabName: "authList",
            displayerromessage:false
        };
    }


    onPageChange = (page, pageSize) => {
        console.log(page)
        console.log(pageSize)
        
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getAuthorizationsListfromCA(false);
            }
        );
    }

    resetFields = () => {
        this.setState(
            {
                filterReq: "",
                filterAbv: "",
                filtercptCode: "",
                filterposAbb: "",
                filterproviderNPI: "",
                filtersubscriberID: "",
                filterreceivedDate: "",
                filterReference: "",
                filterSubId: "",
                filterMemberName: "",
                filterFromData: "",
                filterToData: "",

                filterStatus: "",
                filterPos: "",
                filterAuth: "",
            },
            () => {
                this.getAuthorizationsListfromCA(true);
                this.props.form.setFieldsValue({
                    filterToData: "",
                });
                this.props.form.setFieldsValue({
                    filterFromData: "",
                });
                this.props.form.setFieldsValue({
                    filterreceivedDate: "",
                });
            }
        );
    };

    getAuthorizationsListfromCA(value) {
        var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
        console.log("mappingData",mappingDataString)
        var npiArray = [];
        if (mappingDataString) {
            try {
                var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
                mappingData.forEach(item => {
                  if (Array.isArray(item.NPI)) {
                    item.NPI.forEach(npi => npiArray.push(npi));
                  }
                });
                console.log("npiArray:", npiArray); 
              } catch (e) {
                console.error("Failed to parse mappingData", e);
              }
            
        }else{
            npiArray =  JSON.parse(sessionStorage.getItem("npivalue"));
            console.log(npiArray)
        }
        let postData = {}
        if (value === true) {
            this.setState({
                pageNumber:1
            })
            postData = {
                pageNumber: 1,
                pageSize: this.state.pageSize,
                authorizationNumber: this.state.filterReference,
                cPTCode: this.state.filtercptCode,
                memberName: this.state.filterMemberName,
                fromDate: this.state.filterFromData,
                toDate: this.state.filterToData,
                posAbb: this.state.filterposAbb,
                receivedDate:this.state.filterreceivedDate,
                subscriberID: this.props.fromPage === "Member Search" || this.props.fromPage === "Check Eligibility"
                    ? this.props.User?.SubscriberID
                    : this.state.filtersubscriberID,
                providerNpi:npiArray,

            }
        } else if  (value === "downloadExcel") {

            postData = {
                pageNumber: 1,
                pageSize:  this.state.pageSize,
                authorizationNumber: this.state.filterReference,
                cPTCode: this.state.filtercptCode,
                memberName: this.state.filterMemberName,
                fromDate: this.state.filterFromData,
                toDate: this.state.filterToData,
                posAbb: this.state.filterposAbb,
                receivedDate:this.state.filterreceivedDate,
                subscriberID:
                this.props.fromPage === "Member Search" || this.props.fromPage === "Check Eligibility"
                    ? this.props.User?.SubscriberID
                    : this.state.filtersubscriberID,
                providerNpi:npiArray,
            }

        } else {
            postData = {
                pageNumber: this.state.pageNumber,
                pageSize:  this.state.pageSize,
                authorizationNumber: this.state.filterReference,
                cPTCode: this.state.filtercptCode,
                memberName: this.state.filterMemberName,
                fromDate: this.state.filterFromData,
                toDate: this.state.filterToData,
                posAbb: this.state.filterposAbb,
                receivedDate:this.state.filterreceivedDate,
                subscriberID:this.props.fromPage === "Member Search" || this.props.fromPage === "Check Eligibility"
            ? this.props.User?.SubscriberID
            : this.state.filtersubscriberID,
                providerNpi:npiArray,
            }
        }

        let axiosConfig = {
            headers: {
                Authorization: sessionStorage.getItem("access_token"),
                Accept: "application/json",
                "Content-type": "application/json",
            },
        };
        
        Axios.post(Config.Auth + "/GetAllAuthorizationFromCA?Planname="+ sessionStorage.getItem("planName"), postData, axiosConfig)
            .then((res) => {

                console.log("res", res.data)
                console.log("res", res.data.Status)

                // Convert date fields
                if(res.data.Status === undefined){
                var formattedData = res.data.data.map(item => ({
                    ...item,
                    fromDate: this.formatDate(item.fromDate),
                    toDate: this.formatDate(item.toDate),
                    receivedDate: this.formatDate(item.receivedDate)
                }));
                
                console.log("formattedData", formattedData);
                this.setState({
                    authListData: formattedData,
                    filterData: formattedData,
                    authListLoading: true,
                    SearchLoading: false,
                    totalCount: res.data.totalCount,
                    totalPagescount: res.data.totalPages,
                    displayerromessage:false

                })
            }

                if(res.data.Status === "Invalid Request"){
                    this.setState({
                        filterData:[],
                        authListData:[],
                        SearchLoading: false,
                        authListLoading: true,
                        displayerromessage:true,
                    })
                }
                if (value === "downloadExcel") {
                    let data = res.data.data;
                    let option = {};
                    let dataTable = [];
                    if (data.length > 0) {
                        if (data) {
                            for (let i in data) {
                                let obj = {
                                    referenceNumber: data[i].referenceNumber,
                                    memberName: data[i].memberName,
                                    subscriberID: data[i].subscriberID,
                                    providerNPI: data[i].providerNPI,
                                    posAbb: data[i].posAbb,
                                    FromDate: this.formatDate(data[i].fromDate),
                                    ToDate: this.formatDate(data[i].toDate),
                                    cptCode: data[i].cptCode,
                                    receivedDate: this.formatDate(data[i].receivedDate),
                                    authStatus: data[i].authStatus,
                                };
                                dataTable.push(obj);
                            }
                        }
                    }
                    option.fileName = "Auth List";
                    option.datas = [
                        {
                            sheetData: dataTable,
                            sheetName: "Auth List",
                            sheetHeader: [
                                "Reference",
                                "Member Name",
                                "Sub ID",
                                "Provider NPI",
                                "POS",
                                "From Date",
                                "To Date",
                                "Cpt Code",
                                "Received Date",
                                "Auth Status",
                            ],
                        },
                    ];
                    let toExcel = new ExportJsonExcel(option);
                    toExcel.saveExcel();
                }
            })

    }


    componentDidMount() {

        this.getAuthorizationsListfromCA(false)

    }

    componentDidUpdate() {
        // $("ul li.active").removeClass("active");
        // $("ul li#" + this.state.currentPage).addClass("active");
        // this.AdmissionListUpdatedbyEvents()
    }
    filterOnchange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value,
            // currentPage : 1
        });
    };

    funfilterProviderNPI = (e) => {
        const value = e.target.value;
      
        this.setState({ filterproviderNPI: value }, () => {
          if (value.trim() === "") {
            // Input cleared, reset filterData to originalData
            this.setState({ filterData: this.state.authListData });
          } else {
            // Apply filter
            const filtered = this.state.authListData.filter(item =>
              item.providerNPI && item.providerNPI.includes(value)
            );
            this.setState({ filterData: filtered });
          }
        });
      };

    

    columnAscendingOrder = (event, sortKey) => {
        const data = this.state.authListData;
        data.sort((a, b) => {
            const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
            const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
            return a1.localeCompare(b1);
        });
        this.setState({ data });
    };

    ColumnDescendingOrder = (event, sortKey) => {
        const data = this.state.authListData;
        data.sort((a, b) => {
            const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
            const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
            return b1.localeCompare(a1);
        });
        this.setState({ data });
    };


    fromdateOnChange = (date, dateString) => {
        this.props.form.setFieldsValue(
            {
                filterFromData : date,
            },
            
          );
        this.setState({
            filterFromData: dateString,
        });
    };

    todateOnChange = (date, dateString) => {
        //console.log(date)
        console.log(dateString)
        this.props.form.setFieldsValue(
            {
                filterToData : date,
            },
            
          );
        this.setState({
            filterToData: dateString,
        });
    };

     receiveddateOnChange = (date, dateString) => {
        //console.log(date)
        console.log(dateString)
        this.props.form.setFieldsValue(
            {
                filterreceivedDate : date,
            },
            
          );
        this.setState({
            filterreceivedDate: dateString,
        });
    };


    paginationIncrement = () => {
        // if(this.state.totalRecords != this.state.currentPage){
        //     alert("hi")
        // }
        this.setState(
          {
            pageSize: this.state.pageSize + 10,
            filterData:[],
            authListData:[],
            SearchLoading:true
         
            
            
          },
    
          () =>
          this.getAuthorizationsListfromCA(true)
        );
      };

      paginationDecrement = () => {
        if (this.state.pageSize > 10) {
          this.setState(
            {
                pageSize: this.state.pageSize - 10,
                filterData:[],
                authListData:[],
                SearchLoading:true
              
            },
            () =>
            this.getAuthorizationsListfromCA(true)
          );
        } else {
          this.setState(
            {
                pageSize: this.state.pageSize,
                filterData:[],
                authListData:[],
                SearchLoading:true
             
            },
            () =>
            this.getAuthorizationsListfromCA(true)
          );
        }
        // this.getAuthorizationsList(false, this.state.currentPage,this.state.upperPageBound,this.state.lowerPageBound,this.state.pageBound, this.state.isPrevBtnActive, this.state.isNextBtnActive)
      };

    tableHeader = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <thead>
                <tr>
                    <th>
                        <div style={{ marginTop: "-30px" }}>
                            <div>#</div>
                        </div>
                    </th>
                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div> {this.state.columnHeadersForsonder[0]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "referenceNumber")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "referenceNumber")}
                                    ></div>
                                </div>
                            </div>

                            <div>
                                <Input
                                    className="inputStyle"
                                    name="filterReference"
                                    type="text"
                                    value={this.state.filterReference}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    size="small"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[1]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "memberName")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "memberName")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filterMemberName"
                                    type="text"
                                    value={this.state.filterMemberName}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[2]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "subscriberID")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "subscriberID")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filtersubscriberID"
                                    type="text"
                                    value={this.state.filtersubscriberID}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div style={{ marginTop: "-8px" }}>
                                    {this.state.columnHeadersForsonder[3]}
                                </div>
                                <div style={{ marginTop: "-10px" }}>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "providerNPI")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "providerNPI")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filterproviderNPI"
                                    type="text"
                                    value={this.state.filterproviderNPI}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>
                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div style={{ marginTop: "-8px" }}>
                                    {this.state.columnHeadersForsonder[4]}
                                </div>
                                <div style={{ marginTop: "-10px" }}>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "posAbb")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "posAbb")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filterposAbb"
                                    type="text"
                                    value={this.state.filterposAbb}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[5]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "fromDate")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "fromDate")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                {getFieldDecorator("filterFromData", {
                                    initialValue:
                                        this.state.filterFromData != "" || this.state.filterFromData != null
                                            ? this.state.filterFromData
                                            : "",
                                })(
                                    <DatePicker
                                        size="small"
                                        suffixIcon
                                        className="inputStyle datePicker"
                                        style={{ width: "100%", marginTop: "10px" }}
                                        onChange={(date, dateString) => this.fromdateOnChange(date, dateString)}
                                        format={"MM/DD/YYYY"}
                                        placeholder="Select"
                                    />
                                )}{" "}
                            </div>
                        </div>
                    </th>
                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div style={{ marginTop: "-8px" }}>
                                    {this.state.columnHeadersForsonder[6]}
                                </div>
                                <div style={{ marginTop: "-10px" }}>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "ToDate")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "ToDate")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                {getFieldDecorator("filterToData", {
                                    initialValue:
                                        this.state.filterToData != "" || this.state.filterToData != null
                                            ? this.state.filterToData
                                            : "",
                                })(
                                    <DatePicker
                                        size="small"
                                        suffixIcon
                                        className="inputStyle datePicker"
                                        style={{ width: "100%", marginTop: "10px" }}
                                        onChange={(date, dateString) => this.todateOnChange(date, dateString)}
                                        // disabledDate={d =>
                                        //     !d || d.isAfter(today, "day")
                                        // }
                                        format={"MM/DD/YYYY"}
                                        placeholder="Select"
                                    />
                                )}{" "}
                            </div>
                        </div>
                    </th>

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[7]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "cptCode")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "cptCode")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filtercptCode"
                                    type="text"
                                    value={this.state.filtercptCode}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>  

                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[8]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "receivedDate")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "receivedDate")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                {getFieldDecorator("filterreceivedDate", {
                                    initialValue:
                                        this.state.filterreceivedDate != "" || this.state.filterreceivedDate != null
                                            ? this.state.filterreceivedDate
                                            : "",
                                })(
                                    <DatePicker
                                        size="small"
                                        suffixIcon
                                        className="inputStyle datePicker"
                                        style={{ width: "100%", marginTop: "10px" }}
                                        onChange={(date, dateString) => this.receiveddateOnChange(date, dateString)}
                                        // disabledDate={d =>
                                        //     !d || d.isAfter(today, "day")
                                        // }
                                        format={"MM/DD/YYYY"}
                                        placeholder="Select"
                                    />
                                )}{" "}
                            </div>
                        </div>
                    </th>
                     


                    <th>
                        <div>
                            <div className="sortingArrows">
                                <div>{this.state.columnHeadersForsonder[9]}</div>
                                <div>
                                    <div
                                        className="triangle triangle-4"
                                        onClick={(e) => this.columnAscendingOrder(e, "authStatus")}
                                    ></div>
                                    <div
                                        className="triangle triangle-5"
                                        onClick={(e) => this.ColumnDescendingOrder(e, "authStatus")}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <Input
                                    size="small"
                                    className="inputStyle"
                                    name="filterAuth"
                                    type="text"
                                    value={this.state.filterAuth}
                                    onChange={this.filterOnchange}
                                    placeholder="Enter"
                                    onPressEnter={() =>
                                        this.getAuthorizationsListfromCA(false)
                                    }
                                />
                            </div>
                        </div>
                    </th>
                    
                    
                    
                    
                    
                   
                    

                </tr>
            </thead>
        );
    };


    // Helper function to format date
      formatDate(isoDate) {
        return isoDate ? dayjs(isoDate).format("MM/DD/YYYY") : "";
    // const date = new Date(isoDate);
    // return `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
    //        `${date.getDate().toString().padStart(2, '0')}/` +
    //        `${date.getFullYear()}`;
  }
  

    // formatDate = (isoDateString) => {

    //     return isoDateString ? dayjs(isoDateString).format("MM/DD/YYYY") : "";
    //     // if (!isoDateString) return "";
    //     // const date = new Date(isoDateString);
    //     // return date.toLocaleDateString("en-US"); // Formats to MM/DD/YYYY
    //     // console.log(isoDateString)
    //     // const date = new Date(isoDateString);
    //     // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    //     // const day = String(date.getDate()).padStart(2, '0');
    //     // const year = date.getFullYear();
    //     // return `${month}/${day}/${year}`;
    // };

    cleanText = (text) => {
        if (!text) return "";
        return text
            .replace(/\\/g, '')          // Remove backslashes
            .replace(/"/g, '')           // Remove double quotes
            .toLowerCase()               // Convert all to lowercase
            .split(' ')                  // Split into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
            .join(' ');                  // Join words back
    };

    

    render() {
        // console.log(typeof(this.props.taxId))
        // console.log("-props in auth page", this.props.subId);


        const { getFieldDecorator } = this.props.form;
        //console.log(this.state.authListData)
        console.log(this.state.displayerromessage)
        // var currentTodos;
       // this.state.filterData = this.state.authListData
        if(this.state.authListData !== undefined){
        this.state.filterData = this.state.authListData.filter((e) => {
            var ReferenceNumber =  e.referenceNumber === null || e.referenceNumber === undefined ? "" : e.referenceNumber.replace(/\s+/g, " ");
            var MemberName = e.memberName === null || e.memberName === undefined ? "" : e.memberName.replace(/\s+/g, " ");
            var Subid = e.subscriberID === null || e.subscriberID === undefined ? "" : e.subscriberID.replace(/\s+/g, " ");
             var ProviderNPI = e.providerNPI === null || e.providerNPI === undefined ? "" : e.providerNPI.replace(/\s+/g, " ");
             var PosAbb = e.posAbb === null || e.posAbb === undefined ? "" : e.posAbb.replace(/\s+/g, " ");
             var Fromdate = e.fromDate === null || e.fromDate === undefined ? "" : e.fromDate.replace(/\s+/g, " ");
             var Todate = e.toDate === null || e.toDate === undefined ? "" : e.toDate.replace(/\s+/g, " ");
             var ReceivedDate = e.receivedDate === null || e.receivedDate === undefined ? "" : e.receivedDate.replace(/\s+/g, " ");
             var CptCode = e.cptCode === null || e.cptCode === undefined ? "" : e.cptCode.replace(/\s+/g, " ");
             var AuthStatus = e.authStatus === null || e.authStatus === undefined ? "" : e.authStatus.replace(/\s+/g, " ");

            return (
                
                ReferenceNumber.toLowerCase().includes(this.state.filterReference.toLowerCase()) &&
                MemberName.toLowerCase().includes(this.state.filterMemberName.toLowerCase()) &&
                Subid.toLowerCase().includes(this.state.filtersubscriberID.toLowerCase()) &&
                ProviderNPI.toLowerCase().includes(this.state.filterproviderNPI.toLowerCase()) &&
                PosAbb.toLowerCase().includes(this.state.filterposAbb.toLowerCase()) &&
                CptCode.toLowerCase().includes(this.state.filtercptCode.toLowerCase()) &&
                AuthStatus.toLowerCase().includes(this.state.filterAuth.toLowerCase()) &&
                Fromdate.toLowerCase().includes(this.state.filterFromData.toLowerCase()) &&
                Todate.toLowerCase().includes(this.state.filterToData.toLowerCase())  &&
                ReceivedDate.toLowerCase().includes(this.state.filterreceivedDate.toLowerCase()) 
              );

        })
    }

        console.log(this.state.filterData)

        const pageNumbers = [];

        return (
            <div>

                {this.props.fromPage && (
                    <div>
                        {/* <ErrorBoundaries> */}
                        {/* <AddEventBlock
              uniqueId={this.props.uniqueId}
              dataCount={this.state.filterData.length}
              tabName="Auth"
              userDetails={this.props.memberDetails}
              callerId={this.props.callerId}
              activeKey={this.props.activeKey}
            /> */}
                        {/* </ErrorBoundaries> */}
                    </div>
                )}
                <div className="mydiv">
                    <table style={{ display: 'block' }} className="authTable">{this.tableHeader()}</table>
                    {(this.state.filterReference != null && this.state.filterReference != "") ||
                        (this.state.filtercptCode != null && this.state.filtercptCode != "") ||
                        (this.state.filterSubId != null && this.state.filterSubId != "") ||
                        (this.state.filterAuth != null && this.state.filterAuth != "") ||
                        (this.state.filterMemberName != null && this.state.filterMemberName != "") ||
                        (this.state.filterToData != null && this.state.filterToData != "") ||
                        (this.state.filterFromData != null && this.state.filterFromData != "") ||
                        (this.state.filterproviderNPI != null && this.state.filterproviderNPI != "") ||
                        (this.state.filterreceivedDate != null && this.state.filterreceivedDate != "") ||
                        (this.state.filtersubscriberID != null && this.state.filtersubscriberID != "") ||
                        (this.state.filterposAbb != null && this.state.filterposAbb != "") ? (
                        <div className="AuthpositionRight">
                            <span className="authCrossButtonBg" onClick={this.resetFields}>
                                <img
                                    className="actionButtons"
                                    src={CrossIcon}
                                    style={{ width: "11px", height: "11px" }}
                                />
                            </span>
                            <span
                                className="authSearchButtonBg"
                                onClick={() =>
                                    this.getAuthorizationsListfromCA(true)
                                }
                            >
                                <img
                                    className="actionButtons"
                                    src={SearchIcon}
                                    width="13"
                                    height="13"
                                />
                            </span>
                        </div>
                    ) : (
                        ""
                    )}

                    <table className="authTable authTable2" >
                        <tbody className="tableBody">
                            {Array.isArray(this.state.filterData) && this.state.filterData.length > 0 && this.state.SearchLoading === false &&
                                this.state.authListLoading === true &&
                                this.state.filterData.map((user, index) => {
                                    if (index <= 8) {
                                        var serialNumber = "0" + (index + 1);
                                    } else {
                                        var serialNumber = index + 1;
                                    }
                                    // this.state.serialNumber = this.state.todosPerPage * (this.state.currentPage - 1) + index + 1
                                    return (
                                        <tr >
                                            {/* <td>{this.state.todosPerPage * (this.state.currentPage - 1) + index + 1}.</td> */}
                                            <td>{serialNumber}</td>

                                            <td><EllipsisWithTooltip>{user.referenceNumber}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{this.cleanText(user.memberName)}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.subscriberID}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.providerNPI}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.posAbb}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.fromDate}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.toDate}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.cptCode}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.receivedDate}</EllipsisWithTooltip></td>
                                            <td><EllipsisWithTooltip>{user.authStatus}</EllipsisWithTooltip></td>
                                            
                                            
                                            
                                            
                                            
                                           
                                            
                                            {/* <td>  <EllipsisWithTooltip>{user.ServicingProvider}</EllipsisWithTooltip></td>
                    <td><EllipsisWithTooltip>{user.FacilityName}</EllipsisWithTooltip></td> */}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    {
                        (this.state.SearchLoading === true && sessionStorage.getItem("planName") === 'ultimate') &&
                        <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                            <Spin size="large" tip="Loading..." />
                        </div>
                    }
                    { Array.isArray(this.state.filterData) &&  this.state.filterData.length === 0 && this.state.SearchLoading === false &&
                        this.state.authListLoading === false && (
                            <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                                <Spin size="large" tip="Loading..." />
                            </div>
                        )}
                    { Array.isArray(this.state.filterData) && this.state.filterData.length === 0 && this.state.SearchLoading === false && this.state.displayerromessage === false &&
                        this.state.authListLoading === true && (
                            <div className="mt-5 mb-5 h5 d-flex justify-content-center ">
                                <span>No Record Found !</span>
                            </div>
                        )}

                   { this.state.displayerromessage === true && (
                            <div className="mt-5 mb-5 h5 d-flex justify-content-center ">
                                <span>No Record Found !</span>
                            </div>
                        )}
                </div>
                { Array.isArray(this.state.filterData) && this.state.filterData.length > 0 && (
                   <div style={{ marginTop: "10px", marginBottom: "20px" }}>
                   <div
                     style={{
                       display: "flex",
                       flexDirection: "row",
                       justifyContent: "space-between",
                       alignItems: "center", // vertically center
                     }}
                   >
                     {/* Left side - Pagination */}
                     <div>
                       <Pagination
                         size="small"
                         hideOnSinglePage={true}
                         current={this.state.pageNumber}
                         total={this.state.totalCount}
                         defaultPageSize={this.state.pageSize}
                         showSizeChanger={false}
                         onChange={this.onPageChange}
                       />
                     </div>
                 
                     {/* Right side - Download button */}
                     <div style={{marginLeft:"58%"}}>
                {this.state.totalCount > 10 ? (
                  <div className="page-bottom-pagination-buttons">
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationIncrement}
                    >
                      <img
                        src={paginationIncrement}
                        alt="IncrementIcon"
                        style={{
                          width: "9px",
                          height: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                    <span className="page-bottom-buttons-text ">
                      <b>{this.state.pageSize}</b>
                      <b>Rows</b>
                    </span>
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationDecrement}
                    >
                      <img
                        src={paginationDecrement}
                        alt="DecrementIcon"
                        style={{
                          width: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
                     <div style={{marginRight:"2%"}}>
                       <button
                         className="page-bottom-downolad-button"
                         type="submit"
                         onClick={() => this.getAuthorizationsListfromCA("downloadExcel")}
                       >
                         <img
                           src={DownloadIcon}
                           alt="downloadIcon"
                           className="page-bottom-download-icon"
                         />
                         <span className="page-bottom-download-text">Download</span>
                       </button>
                     </div>
                   </div>
                 </div>
                 
                )}

            </div>

        );
    }
}

// export default AuthUserListsonder;
export default Form.create({ name: "AuthUserListsonder" })(AuthUserListsonder);
